"use client";

import { Box, Flex, Link, Text } from "@chakra-ui/react";
import React from "react";

interface ICtaBarProps {
  title: string;
  description: string;
  ctaText: string;
  ctaLink: string;
}

const CtaBar = ({ title, description, ctaText, ctaLink }: ICtaBarProps) => {
  return (
    <Box background="#f3f3f3" width="100%" padding="35px 20px;">
      <Box className="container">
        <Flex alignItems="center" justifyContent="space-between">
          <Box>
            <Text textStyle="h2" as="h2">
              {title}
            </Text>
            <Text textStyle="p" as="p">
              {description}
            </Text>
          </Box>
          <Box>
            <Link
              className="button button--light button--large"
              flexShrink="0"
              href="/"
            >
              Arrange a call
            </Link>
          </Box>
        </Flex>
      </Box>
    </Box>
  );
};

export default CtaBar;
